import {
  Avatar,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Text,
  Button,
  Portal,
  Select,
  Box,
} from '@chakra-ui/react';
import { FaChevronDown, FaExternalLinkAlt } from 'react-icons/fa';
import { MarketplaceContext } from 'src/contexts/marketplace';
import { useContext } from 'react';
import { srcFromCDN } from 'src/utils/files';
import { getMarketplaceLink } from 'src/utils/domainUtils';

const AdminRouteMarketplaceProfile = () => {
  const { marketplace, adminMarketplaceOptions, changeAdminMarketplace } =
    useContext(MarketplaceContext);
  const marketplaceLink = marketplace ? getMarketplaceLink(marketplace) : '';
  const marketplaceName = marketplace ? marketplace.name : 'Loma Admin';
  const marketplaceLogo = marketplace
    ? srcFromCDN(marketplace.logo_image, 32)
    : '/images/loma-admin-logo.png';

  // If user is authenticated, show avatar with dropdown menu
  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        p={0}
        w="full"
        h="10"
        cursor={marketplace ? 'pointer' : 'default'}
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
      >
        <Flex alignItems="center" gap={2} w="full">
          {marketplace && (
            <Avatar
              size="sm"
              name={marketplaceName}
              src={marketplaceLogo}
              bgColor="white"
              showBorder
              borderColor="gray.200"
            />
          )}
          <Text fontSize="sm" fontWeight="medium" isTruncated maxW="160px" paddingTop="4px">
            {marketplaceName}
          </Text>
          {marketplace && <FaChevronDown size={10} style={{ marginLeft: 'auto' }} />}
        </Flex>
      </MenuButton>
      {marketplace && (
        <Portal>
          <MenuList w="260px" zIndex={99999}>
            <MenuItem
              onClick={() => {
                window.open(marketplaceLink, '_blank');
              }}
              fontSize="sm"
            >
              <Flex alignItems="center" justifyContent="space-between" w="full">
                <Text>Go to {marketplaceName}</Text>
                <FaExternalLinkAlt />
              </Flex>
            </MenuItem>
            {adminMarketplaceOptions.length > 1 && (
              <>
                <MenuDivider />
                <Box px={3} py={2}>
                  <Text fontSize="xs" fontWeight="semibold" color="gray.500" mb={2}>
                    Switch Marketplace
                  </Text>
                  <Select
                    value={marketplace?.id || ''}
                    onChange={(e) => changeAdminMarketplace(Number(e.target.value))}
                    size="sm"
                    fontSize="sm"
                  >
                    {adminMarketplaceOptions.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name} [{option.slug}]
                      </option>
                    ))}
                  </Select>
                </Box>
              </>
            )}
          </MenuList>
        </Portal>
      )}
    </Menu>
  );
};

export default AdminRouteMarketplaceProfile;
